import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import * as MySound from '../../MySound';
import RF_AdditionalInfo from '../RFTransfers/RF_AdditionalInfo';

export class RF_Put extends Component {
    static displayName = RF_Put.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            loading: false,
            fromLocationBarcode: "",
            fromLocationId: "",
            namecode: "",
            createdDocket: 0,
            inventoriesInTransfer: [],
            scannedProductBarcode: "",
            unitsToTransferIn: 0,
            displayAdditionalInfo: false,
            inventoriesToPut: [],
            clientName: ""
        }
    }

    componentDidMount() {
        if (MyGlobal.rf_transfer) {
            var rf_transfersettings = JSON.parse(MyGlobal.rf_transfer);
            if (rf_transfersettings) {
                this.setState({
                    fromLocationId : rf_transfersettings.fromLocationId,
                    fromLocationBarcode : rf_transfersettings.fromLocationBarcode,
                    createdDocket : rf_transfersettings.createdDocket,
                    namecode : rf_transfersettings.namecode,
                    inventoriesInTransfer: rf_transfersettings.inventoriesInTransfer,
                    clientName : rf_transfersettings.clientName
                });
               
            }
        }
    }

    confirmAdditionalInfoCloseEvent() {

        this.setState({ displayAdditionalInfo: false });

    }
    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }
   
    validateScannedProductCode() {

        if (!this.state.scannedProductBarcode) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Please scan the Product barcode" });
            return;
        }
        this.state.scannedProductBarcode = this.state.scannedProductBarcode.trim().toUpperCase();
        if (!this.state.inventoriesInTransfer || this.state.inventoriesInTransfer.length <= 0) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "There are no inventories loaded" });
            return;
        }
        var scannedProductBarcode = this.state.scannedProductBarcode;
        const inventory = this.state.inventoriesInTransfer.find((element) => {
            return element.barcode === scannedProductBarcode;
        });
        if (!inventory) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Inventory with barcode: " + scannedProductBarcode + " not found in the list of inventories for this location" });
            return;
        }
       
        inventory.namecode = this.state.namecode;
        inventory.clientName = this.state.clientName;
        inventory.expiryDate = inventory.grades?.expiryDate;
        inventory.packingDate = inventory.grades?.packingDate;
        this.state.inventoriesToPut = [inventory];
        const validateTransferRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Inventories: [inventory],
                DestinationLocationId: this.state.fromLocationId,
                DestinationLocationBarcode: this.state.fromLocationBarcode,
                WarehouseId: MyGlobal.warehouse,
            })
        };
        fetch(`api/Transfer/ValidateClientSwitches`, validateTransferRequest)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Failed to validate Client Switches!!" + errorText, loading: false });
                    return;
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {

                        if (apiResponse.success) {
                            this.state.scannedInventory = inventory;
                            MySound.play(MySound.Sound.next);
                            this.goto('RF_ConfirmPut');

                        }
                        else {
                            MySound.play(MySound.Sound.stop);
                            this.setState({ alertMessage: apiResponse.errorMessage, loading: false });
                        }


                    }
                    else {
                        this.setState({ alertMessage: "Failed to validate Client Switches!!", loading: false });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error, loading: false });
            });


       
    }
   
    renderInventoryContentsInTransfer() {

        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Code</th>
                        <th>Barcode</th>
                        <th>Description</th>
                        <th>PackingDate</th>
                        <th>ExpiryDate</th>
                        <th>Units</th>
                        <th>Commited</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.inventoriesInTransfer.map((row, index) =>
                        <tr key={index} onClick={() => { this.setState({ scannedProductBarcode: row.barcode, unitsToTransferIn: row.units }) }}>
                            <td>{row.productCode}</td>
                            <td>{row.barcode}</td>
                            <td>{row.productDescription}</td>
                            <td>{row.grades?.packingDate ? new Date(row.grades?.packingDate).toLocaleDateString() : ''}</td>
                            <td>{row.grades?.expiryDate ? new Date(row.grades?.expiryDate).toLocaleDateString() : ''}</td>
                            <td>{row.units}</td>
                            <td>{row.committed}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    render() {

        const alertMessage = this.state.alertMessage;

        const formatAlertMessage = message => {
            return message.split('\r\n').map((line, index) => (
                <React.Fragment key={index}>
                    {line.split('**').map((part, i) =>
                        i % 2 === 1 ? <strong key={i}>{part}</strong> : part
                    )}
                    <br />
                </React.Fragment>
            ));
        };

        let inventoryContentsInTransfer = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderInventoryContentsInTransfer();

        const handleInputKeypress = e => {
            //it triggers by pressing the enter key
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.validateScannedProductCode();
            }
        };

        let displayAdditionalInfoPrompt = this.state.displayAdditionalInfo;
        displayAdditionalInfoPrompt = displayAdditionalInfoPrompt === true ? <RF_AdditionalInfo show={this.state.displayAdditionalInfo} validationMessage={this.state.alertMessage} inventoriesToPut={this.state.inventoriesToPut} toLocation={this.state.fromLocationBarcode} onClickClose={() => { this.confirmAdditionalInfoCloseEvent(); }}  ></RF_AdditionalInfo > : "";

        return (
            <div>
                <Container>
                    <Row>
                        <Col>
                            {alertMessage !== "" && (
                                <MyAlert variant="danger">
                                    {formatAlertMessage(alertMessage)}
                                </MyAlert>
                            )}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('RF_AdhocTransfer'); }} >
                                Back
                            </button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12} >
                            <button type="button"className="btn btn-success col-12 mb-2" onClick={() => { this.setState({ displayAdditionalInfo: true }); }}>Additional Info</button>
                        </Col>
                    </Row>
                  
                    <Row className="mb-3">
                        <Col xs={6}>
                            <label className="small">Client : {this.state.clientName}</label>
                        </Col>
                        <Col xs={6}>
                            <label className="small">Docket : {this.state.createdDocket}</label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><label>Select Product to Put :</label></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <input ref="productBarcodeInputOut" className="form-control" placeholder="Enter Product Barcode"
                                value={this.state.scannedProductBarcode}
                                onChange={(e) => {
                                    this.setState({ scannedProductBarcode: e.target.value });
                                }}
                                readOnly={this.state.sending} onKeyPress={handleInputKeypress} ></input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <button type="button" className="btn btn-success col-12" onClick={() => { this.validateScannedProductCode(); }}  >Next</button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}><h5 className="large">Available Inventory</h5></Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {inventoryContentsInTransfer}
                            </div>
                        </Col>
                    </Row>
                </Container>
                {displayAdditionalInfoPrompt}
            </div>
        );
    }
}